import { Component, inject, OnInit, output, ViewChild } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { PaymentDirections, PaymentSwitchingData } from '@p2p/payment/domain';

import { PayinPayoutSwitchingStore } from './payin-payout-switching.store';

@Component({
    selector: 'lib-payin-payout-switching',
    templateUrl: './payin-payout-switching.component.html',
    styleUrls: ['./payin-payout-switching.component.scss'],
    providers: [PayinPayoutSwitchingStore]
})
export class PayinPayoutSwitchingComponent implements OnInit {
    readonly PaymentDirections = PaymentDirections;

    private readonly payinPayoutSwitchingStore = inject(PayinPayoutSwitchingStore);

    // TODO: сомнительная херота. Нужно подумать закрывать меню не через передачу события вверх по компонентам а через сервис и в рамках архитектуры DDD
    readonly toggleSwitched = output<void>();

    @ViewChild('togglePayin') togglePayin!: MatSlideToggle;
    @ViewChild('togglePayout') togglePayout!: MatSlideToggle;

    readonly switchingData = toSignal(this.payinPayoutSwitchingStore.switchingData$);

    ngOnInit(): void {
        this.payinPayoutSwitchingStore.loadPaymentSwitchingData();
    }

    changeSwitch(toggle: MatSlideToggle, direction: PaymentDirections): void {
        const data = this.switchingData() as PaymentSwitchingData;
        const active = !toggle.checked;

        if (direction === PaymentDirections.PAY_IN) {
            data.payinActive = active;
        } else if (direction === PaymentDirections.PAY_OUT) {
            data.payoutActive = active;
        }

        this.togglePayin.setDisabledState(true);
        this.togglePayout.setDisabledState(true);

        this.payinPayoutSwitchingStore.changeSwitchingData(data);
        this.payinPayoutSwitchingStore.responseEndEvent$.subscribe((error) => {
            this.togglePayin.setDisabledState(false);
            this.togglePayout.setDisabledState(false);

            if (error) {
                toggle.checked = !active;

                return;
            }

            this.toggleSwitched.emit();
        });
    }
}
